module.exports = __webpack_public_path__ + "img/video-circle.3b1370d4.svg";